import React, { useState, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import _ from "lodash";

import { HelpBackgroundFlair } from "../howToPlay/desafiosPicantes";

const allImages = [
  require("../../assets/images/games/hotChallengesPreGame/rabo.png"),
  require("../../assets/images/games/hotChallengesPreGame/algemas.png"),
  require("../../assets/images/games/hotChallengesPreGame/vibrador.png"),
  require("../../assets/images/games/hotChallengesPreGame/camisola.png"),
  require("../../assets/images/games/hotChallengesPreGame/boca.png"),
  require("../../assets/images/games/hotChallengesPreGame/chicote.png"),
  require("../../assets/images/games/hotChallengesPreGame/mascara.png"),
];

export default function DesafiosPreGame() {
  const [phrase, setPhrase] = useState("");
  const images = _.sampleSize(allImages, 4);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const phrases = [
    t("preGameTip1"),
    t("preGameTip2"),
    t("preGameTip3"),
    t("preGameTip4"),
  ];

  useLayoutEffect(() => {
    setPhrase(_.sample(phrases));
  }, []);

  const handleStart = () => {
    navigate("/hot-challenges/game", { state: location.state });
  };

  return (
    <div className="container p-4">
      <HelpBackgroundFlair />
      <div className="flex flex-col h-full">
        <div className="flex flex-col flex-1">
          <div className="flex flex-[2] mt-6 ms-4 me-4">
            <div className="grid grid-cols-2 gap-4">
              {images?.length &&
                images.map((image, index) => {
                  return (
                    <div
                      className="zoom-in"
                      style={{ "--animation-delay": `${index * 300}ms` }}
                      key={`image-${index}`}
                    >
                      <img src={image} alt="" />
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="flex flex-col justify-center flex-1 text-center">
            <span className="font-medium">{t("dica")}</span>
            <p className="font-bold text-xl">{phrase}</p>
          </div>
        </div>
        <div className="mt-4 ms-6 me-6">
          <button
            type="button"
            onClick={handleStart}
            className="btn btn-brand btn-small w-full pt-2 pb-2"
          >
            {t("start")}
          </button>
        </div>
      </div>
    </div>
  );
}
